export default __webpack_public_path__ + "static/media/side_shape.96fe920f.svg";